import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface CouponRateAnnualFormFieldProps {}

export const CouponRateAnnualFormField: React.FC<CouponRateAnnualFormFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ coupon_rate_annual: number }>()

  return (
    <FormField
      name="coupon_rate_annual"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Coupon Rate Annual</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput {...register('coupon_rate_annual')} />
          </FormItem>
        )
      }}
    />
  )
}
